import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export function renderBasicTextWidget(
    context,
    widget,
    parent,
    override = null
) {

    const breakpoint = context.currentBreakpoint;
    const props = widget?.properties?.desktop;

    // Resolve content
    let content = widget.content ?? "";

    if (override?.content) {
        const overrideValue = getContent(
            override.content,
            widget.parameter
        );
        if (overrideValue !== null && overrideValue !== undefined) {
            content = String(overrideValue);
        }
    }

    // Root element
    const el = context.document.createElement("div");
    el.classList.add("widget", "basic_text_widget");
    el.innerHTML = content || "";

    // Base styles
    let styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    if (props) {
        // Auto width
        const width = props.layout?.width;
        const autoWidth = !width || width === "auto";
        if (autoWidth) {
            el.classList.add("auto_width");
        }

        // Font styles
        if (props.font) {
            styles = {
                ...styles,
                ...getFontStyles(props)
            };
        }
    }

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(el);

    return el;
}

function getFontStyles(properties) {
    const styles = {};
    const font = properties.font;

    if (!font) return styles;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;

    if (font.color) {
        styles.color = cssUtil.getCssColor(font.color);
    }

    if (properties.background) {
        styles["background-color"] =
            cssUtil.getCssColor(properties.background);
    }

    if (font.style) {
        if (font.style.bold) styles["font-weight"] = "bold";
        if (font.style.italic) styles["font-style"] = "italic";
        if (font.style.underline) styles["text-decoration"] = "underline";
    }

    return styles;
}

function getContent(mapping, name) {
    if (!mapping) {
      throw new Error("Mapping cannot be null");
    }
    if (!name) {
      throw new Error("Field name cannot be null");
    }
  
    return mapping.fields
      ?.find(field => field.name === name)
      ?.content ?? null;
} 